import { get, post, del, delWithBody, put } from '../request';

export async function fetchModules(
  { userService },
  authenticationToken,
  userType,
) {
  let url = `${userService}/trueprodigy/modules`;
  if (userType) {
    url += `?userType=${userType}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchRoles(
  { userService },
  authenticationToken,
  { moduleId },
) {
  const url = `${userService}/trueprodigy/module/${moduleId}/roles`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createRole(
  { userService },
  authenticationToken,
  { moduleId, role },
) {
  const url = `${userService}/trueprodigy/module/${moduleId}/roles`;
  const { body } = await post(authenticationToken, url, { role });
  return body;
}

export async function deleteRole(
  { userService },
  authenticationToken,
  { moduleId, roleId },
) {
  const url = `${userService}/trueprodigy/module/${moduleId}/role/${roleId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateRole(
  { userService },
  authenticationToken,
  { moduleId, roleId, payload },
) {
  const url = `${userService}/trueprodigy/module/${moduleId}/role/${roleId}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchRights(
  { userService },
  authenticationToken,
  { moduleId },
) {
  const url = `${userService}/trueprodigy/module/${moduleId}/userrights`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchRoleRights(
  { userService },
  authenticationToken,
  { moduleId, roleId },
) {
  const url = `${userService}/trueprodigy/module/${moduleId}/role/${roleId}/userright`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function assignRight(
  { userService },
  authenticationToken,
  { moduleId, roleId, rightId },
) {
  const url = `${userService}/trueprodigy/module/${moduleId}/role/${roleId}/userright`;
  const { body } = await post(authenticationToken, url, {
    userRightIDList: [rightId],
  });
  return body;
}

export async function unAssignRight(
  { userService },
  authenticationToken,
  { moduleId, roleId, rightId },
) {
  const url = `${userService}/trueprodigy/module/${moduleId}/role/${roleId}/userright`;
  const { body } = await delWithBody(
    authenticationToken,
    url,
    {},
    { userRightIDList: [rightId] },
  );
  return body;
}

export async function unAssignAllRights(
  { userService },
  authenticationToken,
  { moduleId, roleId },
) {
  const url = `${userService}/trueprodigy/module/${moduleId}/role/${roleId}/userright/all`;
  const { body } = await del(authenticationToken, url);
  return body;
}
